import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const ConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  title = "Confirm",
  message = "Are you sure you want to continue?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  backdrop = "static",
  children, // Add children prop for additional content
  confirmVariant = "primary", // Allow customization of confirm button variant
  hideFooter = false,
  hideCancel = false,
  style = {}, // Add style prop for custom styling
  disabledConfirm = false,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop={backdrop}
      animation={false}
      style={style}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Render message if provided */}
        {message && <p>{message}</p>}
        {/* Render any additional content passed as children */}
        {children}
      </Modal.Body>

      <Modal.Footer hidden={hideFooter}>
        <Button hidden={hideCancel} variant="light" onClick={onHide}>
          {cancelText}
        </Button>
        <Button
          variant={confirmVariant}
          onClick={onConfirm}
          disabled={disabledConfirm}
        >
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
